import { DownloadIcon } from '@/components/atoms/icons'

export interface BillingCardProps {
  name: string
  period: string
  status: string
  amount: string
  downloadLabel: string
  onDownload: () => void
  imageUrl?: string
  className?: string
  testId?: string
}

export function BillingCard({
  name,
  period,
  status,
  amount,
  downloadLabel,
  onDownload,
  imageUrl,
  className = '',
  testId,
}: BillingCardProps) {
  return (
    <div
      className={`flex flex-col items-center gap-2 overflow-clip rounded-lg border border-neutral-100 bg-white p-4 ${className}`}
      data-testid={testId}
    >
      <div className="flex w-full min-w-0 items-start justify-start gap-2.5">
        <div className="size-8 shrink-0 overflow-hidden rounded-full bg-neutral-100 shadow-[2px_2px_10px_0px_rgba(0,0,0,0.05)]">
          {imageUrl && (
            <img src={imageUrl} alt="" className="size-full object-cover" />
          )}
        </div>
        <div className="flex min-w-0 flex-col gap-1">
          <p className="truncate text-2xl leading-7 font-bold text-neutral-900">
            {name}
          </p>
          <p className="tracking-base text-neutral-base truncate text-xs leading-4 first-letter:uppercase">
            {period} | {status}
          </p>
          <p className="text-base leading-5 font-bold text-neutral-900">
            {amount}
          </p>
        </div>
      </div>

      <hr className="w-full border-t border-dashed border-indigo-50" />

      <button
        type="button"
        onClick={onDownload}
        className="tracking-base text-indigo-base flex h-5 cursor-pointer items-center gap-1 rounded-full pr-4 pl-3.5 text-xs leading-4 hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-800"
        data-testid={testId && `${testId}-download`}
      >
        {downloadLabel}
        <DownloadIcon className="size-4" />
      </button>
    </div>
  )
}
